import {
  FETCH_ACTIVE_PROVIDERS,
  FETCH_ACTIVE_PROVIDERS_FAILURE,
  FETCH_ACTIVE_PROVIDERS_SUCCESS
} from '../constant/actionType';

const initialState = {
  error: null,
  isLoading: false,
  providers: []
};

const providerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVE_PROVIDERS:
      return {
        ...state,
        isLoading: true
      };

    case FETCH_ACTIVE_PROVIDERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      };

    case FETCH_ACTIVE_PROVIDERS_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        providers: action.data
      };
    default:
      return state;
  }
};

export default providerReducer;
